import { invokeApi } from "../../bl_libs/invokeApi";
const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MWZjYTkxNmRmYjY2NjdiZTNjYTg4MzQiLCJsb2dpbl90b2tlbiI6ImIzYTdlNWYwLWZlZWUtMTFlZC1hNmI1LWI1ZTRhODIwOTAwNCIsImxvZ2luX2J5IjoibWVtYmVyX3VzZXIiLCJpYXQiOjE2ODU0NTM2Njh9.2IdH_-OjZfgX4eEMRBrzW11ZUGZj5K3C0r-hvQX1mqU";
export const _get_chat_message = async (url) => {
  const requestObj = {
    path: `${url}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };

  return invokeApi(requestObj);
};

export const _delete_message = async (chat_id, data) => {
  const requestObj = {
    path: `api/chat/delete_message/${chat_id}`,
    method: "POST",
    headers: {
      "x-sh-auth": token,
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _get_chat_history = async () => {
  const requestObj = {
    path: `api/chat/list_chat/delegate`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };

  return invokeApi(requestObj);
};

export const _list_chat_with_event_delegate = async (data) => {
  const requestObj = {
    path: `api/chat/list_chat_with_event_delegate/list/v1?page=0&limit=50`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _get_chat_detail = async (chat_id) => {
  const requestObj = {
    path: `api/chat/chat_detail/${chat_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_chat_list_history = async (data, path) => {
  const requestObj = {
    path: path,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _read_message = (chat_id) => {
  const requestObj = {
    path: `api/chat/read_message/${chat_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };

  return invokeApi(requestObj);
};

export const _unread_message = (message_id) => {
  const requestObj = {
    path: `api/chat/mark_as/unread/${message_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };

  return invokeApi(requestObj);
};

export const _add_chat = async (data) => {
  const requestObj = {
    path: `api/chat/add_chat`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _update_message = async (chat_id, data) => {
  const requestObj = {
    path: `api/chat/update_message/${chat_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": token,
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _send_message = async (data) => {
  const requestObj = {
    path: `api/chat/send_message`,
    method: "POST",
    headers: {
      "x-sh-auth": token,
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _consultant_member_list_with_search = async (data) => {
  const requestObj = {
    path: `api/member/consultant_member_list_delegate/search`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };

  return invokeApi(requestObj);
};

export const _check_chat_existing = async (reciver_id) => {
  const requestObj = {
    path: `api/chat/check_chat_existing/${reciver_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
